/**
 * Influencer testimonials carousel: navigation, responsive scroll behavior, optional autoplay.
 */
(function () {
  function initSection(root) {
    var slider = root.querySelector('[data-influencer-carousel]');
    var slides = root.querySelectorAll('[data-influencer-carousel-slide]');
    var prevButton = root.querySelector('[data-influencer-carousel-prev]');
    var nextButton = root.querySelector('[data-influencer-carousel-next]');

    if (!slider || slides.length < 2) return;

    var autoScrollEnabled = root.dataset.autoScroll === 'true';
    var autoScrollDuration = parseInt(root.dataset.autoScrollDuration, 10) || 5;
    var autoScrollTimer = null;
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var mobileQuery = window.matchMedia('(max-width: 749px)');
    var tabletQuery = window.matchMedia('(min-width: 750px) and (max-width: 989px)');

    /**
     * True when the centered snap carousel is active (mobile full-width or tablet peek).
     */
    function isCenteredCarousel() {
      if (!root.classList.contains('has-mobile-carousel')) return false;
      return mobileQuery.matches || tabletQuery.matches;
    }

    /**
     * Distance to scroll one slide.
     */
    function getScrollStep() {
      if (slides.length < 2) return slider.clientWidth;
      return slides[1].offsetLeft - slides[0].offsetLeft;
    }

    /**
     * Index of the slide closest to the viewport focus (center on mobile, leading edge on desktop).
     */
    function getActiveIndex() {
      if (isCenteredCarousel()) {
        var sliderCenter = slider.scrollLeft + slider.clientWidth / 2;
        var activeIndex = 0;
        var smallestDistance = Infinity;

        slides.forEach(function (slide, index) {
          var slideCenter = slide.offsetLeft + slide.clientWidth / 2;
          var distance = Math.abs(sliderCenter - slideCenter);
          if (distance < smallestDistance) {
            smallestDistance = distance;
            activeIndex = index;
          }
        });

        return activeIndex;
      }

      var scrollPosition = slider.scrollLeft + slider.clientWidth * 0.15;
      var activeIndex = 0;

      slides.forEach(function (slide, index) {
        if (slide.offsetLeft <= scrollPosition) activeIndex = index;
      });

      return activeIndex;
    }

    /**
     * Updates prev/next disabled state from scroll position.
     */
    function updateButtons() {
      if (!prevButton || !nextButton) return;

      var atStart = slider.scrollLeft <= 2;
      var atEnd = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 2;

      prevButton.disabled = atStart;
      nextButton.disabled = atEnd;
    }

    /**
     * Scrolls the carousel to a slide without moving the page.
     */
    function scrollToSlide(index) {
      var slide = slides[index];
      if (!slide) return;

      var slideRect = slide.getBoundingClientRect();
      var sliderRect = slider.getBoundingClientRect();
      var left = slider.scrollLeft + (slideRect.left - sliderRect.left);

      if (isCenteredCarousel()) {
        left -= (slider.clientWidth - slideRect.width) / 2;
      }

      slider.scrollTo({
        left: Math.max(0, left),
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
      });
    }

    /**
     * Advances one slide; loops to start after the last slide.
     */
    function advanceSlide() {
      var atEnd = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 2;

      if (atEnd) {
        slider.scrollTo({ left: 0, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
        return;
      }

      if (isCenteredCarousel()) {
        scrollToSlide(Math.min(slides.length - 1, getActiveIndex() + 1));
        return;
      }

      slider.scrollTo({
        left: slider.scrollLeft + getScrollStep(),
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
      });
    }

    /**
     * Moves one slide backward.
     */
    function retreatSlide() {
      var atStart = slider.scrollLeft <= 2;

      if (atStart) {
        slider.scrollTo({ left: slider.scrollWidth, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
        return;
      }

      if (isCenteredCarousel()) {
        scrollToSlide(Math.max(0, getActiveIndex() - 1));
        return;
      }

      slider.scrollTo({
        left: Math.max(0, slider.scrollLeft - getScrollStep()),
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
      });
    }

    /**
     * Starts autoplay interval when enabled.
     */
    function startAutoScroll() {
      if (!autoScrollEnabled || prefersReducedMotion) return;
      stopAutoScroll();
      autoScrollTimer = window.setInterval(advanceSlide, autoScrollDuration * 1000);
    }

    /**
     * Clears autoplay interval.
     */
    function stopAutoScroll() {
      if (autoScrollTimer) {
        window.clearInterval(autoScrollTimer);
        autoScrollTimer = null;
      }
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        retreatSlide();
        stopAutoScroll();
        startAutoScroll();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        advanceSlide();
        stopAutoScroll();
        startAutoScroll();
      });
    }

    slider.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);

    root.addEventListener('mouseenter', stopAutoScroll);
    root.addEventListener('mouseleave', startAutoScroll);
    root.addEventListener('focusin', stopAutoScroll);
    root.addEventListener('focusout', startAutoScroll);
    root.addEventListener('touchstart', stopAutoScroll, { passive: true });
    root.addEventListener('touchend', startAutoScroll, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAutoScroll();
      else startAutoScroll();
    });

    function onBreakpointChange() {
      updateButtons();
      stopAutoScroll();
      startAutoScroll();
    }

    mobileQuery.addEventListener('change', onBreakpointChange);
    tabletQuery.addEventListener('change', onBreakpointChange);

    updateButtons();
    startAutoScroll();
  }

  function initAll() {
    document.querySelectorAll('[data-influencer-testimonials]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-influencer-testimonials]');
    if (root) initSection(root);
  });
})();
